import ListeFicheConseil from '@/view/Fiches/ListeFicheConseil'

const TABLE_BREADCRUMB = {
  code: 'fiche.list.title',
  link: {
    name: 'fiche/liste',
  },
}

export default [
  {
    path: '/fiche/liste',
    name: 'fiche/liste',
    component: ListeFicheConseil,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
  },
]
